import React, { Fragment } from 'react';
import CallIcon from '@mui/icons-material/Call';
import '../Style/ComunicationPhone.css';




function ComunicationPhone() {
  return (
    <Fragment> 
        <div className='comunicationGeneral'>
            <div className='phoneStyle phonePosition' >
                <a href="tel:+905322005989" target='_blank'><CallIcon className='phoneCall'/></a>
            </div>
        </div> 
    </Fragment>
      

  )
}

export default ComunicationPhone;